<template>
  <v-container>
    <v-layout row justify-center>
      <v-flex xs12 md6 lg4 justify-center>
          <v-text-field
            label="PinCode"
            type="text"
            name="pinCode"
            validate-on-blur
            :rules="getPinValidationRules"
            :placeholder="$t('pincodePlaceholder')"
            v-model="pinCode"
          />
          <br>
          <br>
          <v-btn type="submit" @click="verifyPinCode">{{ $t('confirmPinCode') }}</v-btn>
          <br>
          <br>
          <v-btn type="submit" @click="backToLogin">{{ $t('backToLogin') }}</v-btn>
          <br>
          <br>
          <h3 v-if="error" class="text-xs-center">{{ error }}</h3>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Bugsnag from '../services/Bugsnag'
import UserManagementService from '../services/UserManagementService'
import AuthenticationService from '../services/AuthenticationService'
import CryptoJS from 'crypto-js'
const SECRET_KEY = 'Zlick-TwoFA-Secret-Key-p1nc0d3'

export default {
  name: 'confirmPin',
  data () {
    return {
      email: '',
      pinCode: '',
      getPinValidationRules: [
        v => !!v || this.$t('pincode_required'),
        v => !isNaN(Number(v)) || this.$t('pincode_must_be_number')
      ],
      error: null
    }
  },
  methods: {
    getLocalStorageItems () {
      return {
        email: localStorage.getItem('email'),
        cognitoPinCode: this.decryptProperty('cognitoPinCode'),
        cognitoPinCodeTime: this.decryptProperty('cognitoPinCodeTime'),
        pincodeUsageCount: this.decryptProperty('pincodeUsageCount'),
        currentTime: new Date().getTime()
      }
    },
    async handlePinCodeMatch (items) {
      // The expression 24 * 60 * 60 * 1000 is used to calculate the number of milliseconds in a day.
      let twentyFourHourMilliSeconds = 24 * 60 * 60 * 1000
      if (items.cognitoPinCode && items.currentTime - items.cognitoPinCodeTime < twentyFourHourMilliSeconds && items.pincodeUsageCount < 1) {
        if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) {
          this.$router.push('/telemarketing')
          return
        }
        this.$router.push('/transactions')
        await UserManagementService.updateOtpAndOtpTime(items.email, items.cognitoPinCode, items.cognitoPinCodeTime, 1)
      }
      if (!AuthenticationService.isInRole(['admin', 'support', 'analyst'])) {
        this.$router.push('/telemarketing')
        return
      }
      this.$router.push('/transactions')
    },
    handlePinCodeMismatch () {
      this.error = 'Pincode is Invalid'
      this.$router.replace('/confirmPin')
    },
    async verifyPinCode () {
      const items = this.getLocalStorageItems()
      if (this.pinCode === items.cognitoPinCode) {
        await this.handlePinCodeMatch(items)
      } else {
        this.handlePinCodeMismatch()
      }
    },
    async backToLogin () {
      try {
        this.$router.push('/login')
      } catch (error) {
        this.error = error.message
        Bugsnag.send(error)
      }
    },
    decryptProperty (property) {
      const encryptedProperty = localStorage.getItem(property)
      if (encryptedProperty) {
        const bytes = CryptoJS.AES.decrypt(encryptedProperty, SECRET_KEY)
        const originalProperty = bytes.toString(CryptoJS.enc.Utf8)
        return originalProperty
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/confirmPin.vue